"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Uncertainty = void 0;
var logic_1 = require("./logic");
var Uncertainty = /** @class */ (function () {
    function Uncertainty(low, high) {
        var _a;
        if (low === void 0) { low = null; }
        this.low = low;
        this.high = high;
        var gt = function (a, b) {
            if (typeof a !== typeof b) {
                // TODO: This should probably throw rather than return false.
                // Uncertainties with different types probably shouldn't be supported.
                return false;
            }
            if (typeof a.after === 'function') {
                return a.after(b);
            }
            else {
                return a > b;
            }
        };
        var isNonEnumerable = function (val) {
            return val != null && (val.isCode || val.isConcept || val.isValueSet);
        };
        if (typeof this.high === 'undefined') {
            this.high = this.low;
        }
        if (isNonEnumerable(this.low) || isNonEnumerable(this.high)) {
            this.low = this.high = null;
        }
        if (this.low != null && this.high != null && gt(this.low, this.high)) {
            _a = [this.high, this.low], this.low = _a[0], this.high = _a[1];
        }
    }
    Uncertainty.from = function (obj) {
        if (obj != null && obj.isUncertainty) {
            return obj;
        }
        else {
            return new Uncertainty(obj);
        }
    };
    Object.defineProperty(Uncertainty.prototype, "isUncertainty", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Uncertainty.prototype.copy = function () {
        var newLow = this.low;
        var newHigh = this.high;
        if (typeof this.low.copy === 'function') {
            newLow = this.low.copy();
        }
        if (typeof this.high.copy === 'function') {
            newHigh = this.high.copy();
        }
        return new Uncertainty(newLow, newHigh);
    };
    Uncertainty.prototype.isPoint = function () {
        // Note: Can't use normal equality, as that fails for Javascript dates
        // TODO: Fix after we don't need to support Javascript date uncertainties anymore
        var lte = function (a, b) {
            if (typeof a !== typeof b) {
                return false;
            }
            if (typeof a.sameOrBefore === 'function') {
                return a.sameOrBefore(b);
            }
            else {
                return a <= b;
            }
        };
        var gte = function (a, b) {
            if (typeof a !== typeof b) {
                return false;
            }
            if (typeof a.sameOrBefore === 'function') {
                return a.sameOrAfter(b);
            }
            else {
                return a >= b;
            }
        };
        return (this.low != null && this.high != null && lte(this.low, this.high) && gte(this.low, this.high));
    };
    Uncertainty.prototype.equals = function (other) {
        other = Uncertainty.from(other);
        return logic_1.ThreeValuedLogic.not(logic_1.ThreeValuedLogic.or(this.lessThan(other), this.greaterThan(other)));
    };
    Uncertainty.prototype.lessThan = function (other) {
        var lt = function (a, b) {
            if (typeof a !== typeof b) {
                return false;
            }
            if (typeof a.before === 'function') {
                return a.before(b);
            }
            else {
                return a < b;
            }
        };
        other = Uncertainty.from(other);
        var bestCase = this.low == null || other.high == null || lt(this.low, other.high);
        var worstCase = this.high != null && other.low != null && lt(this.high, other.low);
        if (bestCase === worstCase) {
            return bestCase;
        }
        else {
            return null;
        }
    };
    Uncertainty.prototype.greaterThan = function (other) {
        return Uncertainty.from(other).lessThan(this);
    };
    Uncertainty.prototype.lessThanOrEquals = function (other) {
        return logic_1.ThreeValuedLogic.not(this.greaterThan(Uncertainty.from(other)));
    };
    Uncertainty.prototype.greaterThanOrEquals = function (other) {
        return logic_1.ThreeValuedLogic.not(this.lessThan(Uncertainty.from(other)));
    };
    return Uncertainty;
}());
exports.Uncertainty = Uncertainty;
//# sourceMappingURL=uncertainty.js.map